<template>
  <div class="category-filter">
    <svg v-if="showTodos" class="filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>
    <button
      v-if="showTodos"
      class="filter-btn"
      :class="{ active: categoriaSelecionada === null }"
      @click="$emit('filter-change', null)"
    >
      Todos
    </button>
    <button
      v-for="categoria in categorias"
      :key="categoria.id"
      class="filter-btn"
      :class="{ active: categoriaSelecionada === categoria.id }"
      @click="$emit('filter-change', categoria.id)"
    >
      {{ categoria.descricao }}
    </button>
    <button
      v-if="!showTodos && categoriaSelecionada"
      class="filter-btn clear"
      @click="$emit('filter-change', null)"
    >
      Limpar
    </button>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilter',
  props: {
    categorias: {
      type: Array,
      default: () => []
    },
    categoriaSelecionada: {
      type: [Number, null],
      default: null
    },
    showTodos: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.category-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.filter-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}

.filter-btn {
  padding: 10px 20px;
  border: none;
  background: #e8f5e9;
  border-radius: 24px;
  font-weight: 500;
  color: #2d7a42;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover {
  background: #c8e6c9;
  color: #1b5e20;
}

.filter-btn.active {
  background: #34894d;
  border-color: transparent;
  color: white;
}

.filter-btn.clear {
  border-color: #f56565;
  color: #f56565;
}

.filter-btn.clear:hover {
  background: #f56565;
  color: white;
}
</style>

